import { render, staticRenderFns } from "./NoPaperFiling.vue?vue&type=template&id=447b9434&"
import script from "./NoPaperFiling.vue?vue&type=script&lang=js&"
export * from "./NoPaperFiling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports